import React from "react";

export default function EvaluationQuestionText({ value, onChange, disabled }) {
    return (
        <textarea
            className="qr-textarea"
            value={value || ""}
            onChange={(event) => onChange(event.target.value)}
            disabled={disabled}
            rows={5}
            placeholder="Votre reponse"
        />
    );
}
